document.addEventListener("DOMContentLoaded", function () {
  var classSticky = "sticky";
  var stickyCta = document.querySelector(".sticky-cta-wrapper");
  var shopBox = document.querySelector(".b-shop-home__product-form--wrapper");
  var footer = document.querySelector(".footer");
  var sectionShop = document.querySelector(".b-home-shop__wrapper-main");

  var isInViewport = function (elem) {
    if (!elem) return false;
    var rect = elem.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  var timer;
  var handleScroll = function () {
    if (window.innerWidth <= 768) {
      // Mobile
      if (isInViewport(shopBox)) {
        stickyCta.classList.remove(classSticky); // Hide sticky CTA if shopBox is visible
      } else {
        stickyCta.classList.add(classSticky); // Show sticky CTA otherwise
      }
    } else {
      // Desktop - original logic retained
      if (timer) {
        window.clearTimeout(timer);
      }

      timer = window.setTimeout(function () {
        // Check if the footer is in view
        if (isInViewport(footer)) {
          stickyCta.classList.remove(classSticky);
        }
        // Check if #section-shop is out of the viewport
        else if (!isInViewport(sectionShop)) {
          stickyCta.classList.add(classSticky);
        }
        else if (!isInViewport(shopBox)) {
          stickyCta.classList.add(classSticky);
        } else {
          stickyCta.classList.remove(classSticky);
        }
      }, 100);
    }
  };

  // Run the handler on scroll and page load
  window.addEventListener("scroll", handleScroll);
  handleScroll();
});
